export default __webpack_public_path__ + "static/media/man-success.c603aff9.jpg";